(function () {
  'use strict';

  angular.module('ringbaPortal').component('inAppNotifications', {
    bindings: {
      showMessageId: '<',
      loading: '<'
    },
    controller: InAppNotificationsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/in-app-notifications/in-app-notifications.view.html'
  });

  function InAppNotificationsController(
    _,
    notificationService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.markMessageRead = markMessageRead;
    vm.updateUnread = updateUnread;
    vm.showMoreMessages = showMoreMessages;

    function onInit() {
      vm.activeTab = 0;
      vm.notificationSharedObject = notificationService.sharedNotificationObject;
      _updateMessageCounts();
    }

    function onChanges() {
      if (typeof vm.showMessageId !== 'undefined') {
        vm.selectedMessageId = vm.showMessageId;
        vm.activeTab = 0;
      }
    }

    function markMessageRead(messageId) {
      notificationService.markMessageRead(messageId).then(function () {
        const readMessage = _.find(vm.notificationSharedObject.messages, function (m) {
          return m.id === messageId;
        });

        if (readMessage) {
          readMessage.isRead = true;
        }

        _updateMessageCounts();
        notificationService.updateUnreadMessages();
      });
    }

    function updateUnread() {
      notificationService.updateUnreadMessages();
    }

    function showMoreMessages() {
      notificationService.getMessagesNextPage();
    }

    function _updateMessageCounts() {
      notificationService.getPreviews();
    }
  }
})();
